"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M12 11c-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4 0 2.2091-1.7909 4-4 4Zm-8 7.75C4 14.25 5.9863 12 12 12c3.2739 0 5.3541.6668 6.5701 2.0005C21.0231 14.038 23 16.0381 23 18.5c0 2.4853-2.0147 4.5-4.5 4.5-1.5602 0-2.935-.794-3.7422-2H6c-1.3333 0-2-.75-2-2.25ZM19 18h2v1h-2v2h-1v-2h-2v-1h2v-2h1v2Z", clipRule: "evenodd" })), 'UserPlusSolidIcon');
